export default "__VITE_ASSET__CcnFurfH__"